/* @flow */

import * as React from 'react';

import {StatusBadge} from '../status-badge';
import {Header} from '../typography';

import './onboarding-body.module.css';

type Props = {
    title: string | React.Element<'span'>,
    children: React.Node,
    style?: any,
    statusText?: string,
};

export function OnboardingBody({title, children, style, statusText}: Props) {
    return (
        <div styleName='main-content' style={style}>
            {statusText ? (
                <div styleName='status'>
                    <StatusBadge level='info' text={statusText} />
                </div>
            ) : null}
            <Header>{title}</Header>
            {children}
        </div>
    );
}
